import { Link } from "react-router-dom";
import { Calendar, MapPin } from "lucide-react";
import { fileUrl } from "@/lib/api";

const POSTER_FALLBACK = "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=70&w=800";

const statusLabel = {
  upcoming: "Upcoming",
  coming_soon: "Coming Soon",
  past: "Past Event",
};

export const EventCard = ({ event }) => {
  const minPrice = (event.ticket_categories || []).reduce(
    (m, c) => (c.price < m ? c.price : m), Infinity);
  const poster = event.poster ? fileUrl(event.poster) : POSTER_FALLBACK;

  return (
    <div className="card-dark group flex flex-col overflow-hidden transition-all duration-300 hover:border-[#D4AF37]/50 hover:shadow-2xl hover:shadow-amber-950/20"
      data-testid={`event-card-${event.id}`}>
      <Link to={`/events/${event.id}`} className="relative block aspect-[4/3] overflow-hidden bg-[#0A0A0C]">
        <img src={poster} alt={event.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => { e.currentTarget.src = POSTER_FALLBACK; }} />
        <span className="absolute left-3 top-3 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/20 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-[#E5C158]">
          {statusLabel[event.status] || event.status}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-serif text-xl font-semibold text-white">{event.name}</h3>
        <div className="mt-3 space-y-1.5 text-sm text-zinc-400">
          {event.date && <p className="flex items-center gap-2"><Calendar size={15} className="text-[#D4AF37]" />{event.date}{event.time ? ` • ${event.time}` : ""}</p>}
          {event.venue && <p className="flex items-center gap-2"><MapPin size={15} className="text-[#D4AF37]" />{event.venue}</p>}
        </div>
        <div className="mt-5 flex items-center justify-between border-t border-[#2A2A32] pt-4">
          {minPrice !== Infinity ? (
            <div>
              <p className="text-[10px] uppercase tracking-wider text-zinc-500">From</p>
              <p className="font-serif text-xl font-bold text-[#E5C158]">₹{minPrice}</p>
            </div>
          ) : <span className="text-sm text-zinc-500">Tickets soon</span>}
          <Link to={`/events/${event.id}`} className="btn-gold !px-4 !py-2.5 text-sm" data-testid={`event-card-view-${event.id}`}>
            {event.status === "past" ? "VIEW" : "BOOK NOW"}
          </Link>
        </div>
      </div>
    </div>
  );
};
